import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { motion } from "framer-motion";
import React from "react";
import * as styles from "./Footer.module.css";

export default function Footer(props) {
  return (
    <main className={styles.wrapper}>
      <section>
        <motion.p
          className={styles.copyright}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{
            opacity: 1,
            y: 0,
            transition: { duration: 1, delay: 0.1 },
          }}
          viewport={{ once: false, amount: 0.5 }}
        >
          {props.copyright}
        </motion.p>
      </section>
      <section className={styles.navigation}>
        {props.footeritems.map((footeritem, index) => (
          <div key={index}>
            {footeritem.link.substring(0, 1) === "/" ? (
              <Link to={footeritem.link} aria-label={footeritem.name}>
                <motion.p
                  aria-label={footeritem.name}
                  className={styles.navitem}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{
                    opacity: 1,
                    y: 0,
                    transition: { duration: 1, delay: 0.1 * index },
                  }}
                  viewport={{ once: false, amount: 0.5 }}
                >
                  {footeritem.name}
                </motion.p>
              </Link>
            ) : (
              <a
                href={footeritem.link}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={footeritem.name}
              >
                <motion.p
                  aria-label={footeritem.name}
                  className={styles.navitem}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{
                    opacity: 1,
                    y: 0,
                    transition: { duration: 1, delay: 0.1 * index },
                  }}
                  viewport={{ once: false, amount: 0.5 }}
                >
                  {footeritem.name}
                </motion.p>
              </a>
            )}
          </div>
        ))}
      </section>
      <section className={styles.navigation}>
        {props.socialmedia.map((socialmedia, index) => {
          const image = getImage(socialmedia.Icon.asset.gatsbyImageData);
          return (
            <motion.section
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{
                opacity: 1,
                y: 0,
                transition: { duration: 1, delay: 0.7 + 0.1 * index },
              }}
              viewport={{ once: false, amount: 0.5 }}
            >
              {image && (
                <a
                  href={socialmedia.Link}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={socialmedia.Link}
                >
                  <GatsbyImage
                    className={styles.icons}
                    image={image}
                    alt={socialmedia.alt}
                  />
                </a>
              )}
            </motion.section>
          );
        })}
      </section>
    </main>
  );
}
